import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const HomeAboutSection = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */
    const [section, setSection] = useState({
        heading: "",
        about_section_content_1: "",
        about_section_content_2: "",
        about_section_content_3: "",
    });


    const [image, setImage] = useState(null);
    const [imagePreview, setimagePreview] = useState("");


    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchContent();
    }, []);

    const fetchContent = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/home_page/get_home_page_content/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const aboutContent  = res.data.data.section;
                setSection({
                    heading: aboutContent?.heading || "",
                    about_section_content_1: aboutContent?.about_section_content_1 || "",
                    about_section_content_2: aboutContent?.about_section_content_2 || "",
                    about_section_content_3: aboutContent?.about_section_content_3 || ""
                });

                if (aboutContent?.about_image) {
                    setimagePreview(
                        `${baseAPIUrl}assets/images/home-page/${aboutContent.about_image}`
                    );
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- INPUT HANDLERS ---------------- */
    const handleSectionChange = (e) => {
        setSection({ ...section, [e.target.name]: e.target.value });
    };

    /* ---------------- SUBMIT ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("section", JSON.stringify(section));

            if (image) {
                formData.append("about_image", image);
            }

            const res = await axios.post(
                `${baseAPIUrl}admin/home_page/add_edit_home_page`,
                formData,
                { withCredentials: true }
            );

            fetchContent();
            scrollToTop();
            setMessage(res.data.msg);
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    const handleRemoveImage = async () => {
        const confirmDelete = window.confirm(
            "Are you sure you want to delete this image? This action cannot be undone."
        );

        if (!confirmDelete) return;

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("school_slug", school_slug);
            const res = await axios.post(
                `${baseAPIUrl}admin/home_page/delete_home_about_image`,
                formData ,
                { withCredentials: true }
            );

            if (res.data.status === 1) {
                setimagePreview("");
                setImage(null);
                fetchContent();
                scrollToTop();
                setMessage(res.data.msg);
            } else {
                scrollToTop();
                setMessage(res.data.msg || "Failed to delete image");
            }
        } catch (err) {
            console.error(err);
            scrollToTop();
            setMessage("Failed to delete image.");
        } finally {
            setLoading(false);
            scrollToTop();
        }
    };


    if (loading) return <p>Loading...</p>;

    return (
        <div className="content-wrapper">
            {/* Header */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">
                                Home about section
                            </h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <a href="/admin/dashboard">Dashboard</a>
                                </li>
                                <li className="breadcrumb-item active">
                                    Home page
                                </li>
                                <li className="breadcrumb-item active">
                                    Home about section
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h4>Edit Home about section</h4>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                {message && (
                                    <p className="text-center text-danger">{message}</p>
                                )}

                                {/* Section Fields */}
                                {/* Heading */}
                                <div className="form-group">
                                    <label>Heading</label>
                                    <input
                                        type="text"
                                        name="heading"
                                        className="form-control"
                                        placeholder="Heading title"
                                        value={section.heading}
                                        onChange={handleSectionChange}
                                    />
                                </div>

                                {/* About section content 1*/}
                                <div className="form-group">
                                    <label>About section content</label>
                                    <label className="mt-3">Paragraph 1</label>
                                    <textarea
                                        name="about_section_content_1"
                                        rows="5"
                                        className="form-control"
                                        value={section.about_section_content_1}
                                        placeholder="About section content para 1"
                                        onChange={handleSectionChange}
                                    />
                                </div>

                                {/* About section content 2 */}
                                <div className="form-group">
                                    <label className="mt-3">Paragraph 2</label>
                                    <textarea
                                        name="about_section_content_2"
                                        rows="5"
                                        className="form-control"
                                        value={section.about_section_content_2}
                                        placeholder="About section content para 2"
                                        onChange={handleSectionChange}
                                    />
                                </div>

                                {/* About section content 3 */}
                                <div className="form-group">
                                    <label className="mt-3">Paragraph 3</label>
                                    <textarea
                                        name="about_section_content_3"
                                        rows="5"
                                        className="form-control"
                                        value={section.about_section_content_3}
                                        placeholder="About section content para 3"
                                        onChange={handleSectionChange}
                                    />
                                </div>

                                {/* Image Upload */}
                                <div className="form-group">
                                    <label>About section image</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept="image/*"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                setImage(file);
                                                setimagePreview(URL.createObjectURL(file));
                                            }
                                        }}
                                    />
                                    {imagePreview && (
                                        <div style={{ marginTop: "10px" }}>
                                            <img
                                                src={imagePreview}
                                                alt="About section image Preview"
                                                style={{ maxWidth: "120px", display: "block", marginBottom: "8px" }}
                                            />

                                            <button
                                                type="button"
                                                className="btn btn-sm btn-danger"
                                                onClick={handleRemoveImage}
                                            >
                                                Remove Image
                                            </button>
                                        </div>
                                    )}
                                </div>

                            </div>

                            <div className="card-footer">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomeAboutSection;
